import { FieldProps } from 'formik'
import React from 'react'
import { Form } from 'react-bulma-components'
import FormField, { FormFieldProps } from './form-field'

interface InputFieldProps extends FormFieldProps, FieldProps {
  type: string
}

const InputField: React.FunctionComponent<InputFieldProps> = props => {
  const { field, form, label, help, ...rest } = props
  if (props.field.value === undefined) props.field.value = ''
  const { required } = rest

  // Prevent form submission on Enter key press
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  const id = `${field.name}-input`

  return (
    <FormField
      label={label}
      help={help}
      error={form.errors[field.name] as string}
      required={required}
      htmlFor={id}
    >
      <Form.Input
        {...field}
        {...rest}
        data-test={props.dataTest ?? (rest as Record<string, unknown>)['data-test']}
        onKeyDown={handleKeyDown}
        onWheel={e => rest.type === 'number' && e.currentTarget.blur()}
        id={id}
      />
    </FormField>
  )
}

export default InputField
